import { ActionType } from './';

const defaultState = {
  diagnosisScore: 0,
  modifying: false,
  unappliedSymptoms: '',
}
const symptom = (state: any = defaultState, action: ActionType
  & { unappliedSymptoms: string, diagnosisScore: number, modify?: boolean }) => {
  switch (action.type) {
    case 'WHERE_TO':
      return {
        ...state,
        diagnosisScore: action.diagnosisScore,
        unappliedSymptoms: action.unappliedSymptoms,
      };
    case 'STORE_VALUES':
      return {
        ...state,
        ...action,
      }
    case 'CLEAR_VALUES':
      return {}
    case 'MODIFYING':
      return {
        ...state,
        modifying: action.modify
      }
    default:
      return state
  }
}

export default symptom



// WEBPACK FOOTER //
// ./src/reducers/symptom.ts